import { useAppSelector } from '@/store/hooks';
import type { OrganizationWithMembership, OrganizationDetail, OrgRole } from '@/types/organization';

interface UseOrganizationReturn {
  organizations: OrganizationWithMembership[];
  currentOrgId: string | null;
  currentOrg: OrganizationDetail | null;
  currentOrgWithMembership: OrganizationWithMembership | undefined;
  currentRole: OrgRole | null;
  hasOrg: boolean;
  isLoading: boolean;
  error: string | null;
}

export function useOrganization(): UseOrganizationReturn {
  const organizations = useAppSelector((state) => state.organization.organizations);
  const currentOrgId = useAppSelector((state) => state.organization.currentOrgId);
  const currentOrg = useAppSelector((state) => state.organization.currentOrg);
  const isLoading = useAppSelector((state) => state.organization.isLoading);
  const error = useAppSelector((state) => state.organization.error);

  // Get current org from the organizations list (more reliable than currentOrg)
  const currentOrgWithMembership = organizations.find((o) => o.id === currentOrgId);
  const currentRole =
    currentOrgWithMembership?.membership.role ?? currentOrg?.membership.role ?? null;

  return {
    organizations,
    currentOrgId,
    currentOrg,
    currentOrgWithMembership,
    currentRole,
    hasOrg: !!currentOrgId,
    isLoading,
    error,
  };
}

export default useOrganization;
